<template>
    <div class="e-commerce">
        <ContentBox title="创新定制化合作模式" text="与主流电商平台建立密切的合作关系，依靠成熟的智能化管理及出色的全网配送能力，长期提供量身定制的电商平台解决方案">
            <div class="top">
                <div class="top-pic-wrap">
                    <div class="line">
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_jd.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>产地仓模式</h5>
                                <p>安得智联+京东</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_tm.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>全网大家电送装一体模式</h5>
                                <p>安得智联+天猫</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_wph.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>JIT入仓模式</h5>
                                <p>安得智联+唯品会</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_yx.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>单仓送全国模式</h5>
                                <p>安得智联+网易严选</p>
                            </div>
                        </div>
                    </div>
                    <div class="line line-space">
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_pdd.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>系统对接，平台推荐商家模式</h5>
                                <p>安得智联+拼多多</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_mt.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>仓配一体服务</h5>
                                <p>安得智联+美团</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_my.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>仓配一体服务</h5>
                                <p>安得智联+蜜芽宝贝</p>
                            </div>
                        </div>
                        <div class="pic-item">
                            <div class="pic-item-img">
                                <img src="../../images/icon/logo_zz.png">
                            </div>
                            <div class="pic-item-div">
                                <h5>仓配一体服务</h5>
                                <p>安得智联+汇通达</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ContentBox>
        <div class="middle qwnl-bg">
            <ContentBox title="全国大小件全网能力" theme="white">
                <div class="middle-content">
                    <div class="left">
                        <div
                            :class="{tab: true, active: current === 'tab0'}"
                            @click="showTab('tab0')"
                        >大电网络</div>
                        <div
                            :class="{tab: true, 'tab-space': true, active: current === 'tab1'}"
                            @click="showTab('tab1')"
                        >小电网络</div>
                    </div>
                    <div class="right">
                        <div class="arrow" :class="[current]"></div>
                        <div :class="{'content': true, hide: current !== 'tab0'}">
                            <ul class="dc-list">
                                <li class="dc-item rdc">RDC <span class="dc-num">7</span></li>
                                <li class="dc-item cdc">DC <span class="dc-num">26</span></li>
                            </ul>
                            <img src="../../images/picture/big_map.png">
                        </div>
                        <div :class="{'content': true, hide: current !== 'tab1'}">
                            <img src="../../images/picture/small_map.png">
                        </div>
                    </div>
                </div>
            </ContentBox>
        </div>
    </div>
</template>

<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '安得智联-电商物流|生产物流',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联电商物流,生产物流'
        },{                 // set meta
            name: 'description',
            content: '安得智联电商物流,创新定制化合作模式,与主流电商平台建立密切的合作关系,依靠成熟的智能化管理及出色的全网配送能力,提供量身定制的电商平台解决方案.'
        }]
    },
    name: 'e-commerce',
    data() {
        return {
            current: 'tab0',
            isMobile: this.COMMON.isMobile
        };
    },
    methods: {
        showTab(tab) {
            this.current = tab;
        }
    },
    components: {
        ContentBox
    }
};
</script>

<style lang="less">
.e-commerce {
    img {
        max-width: 100%;
    }
    .banner {
        width: 100%;
        height: 4.8rem;
        background-color: #007cff;
        background-size: 100% 100%;
    }
    .marginBottom {
        margin-bottom: 0;
    }
    .sub-content {
        font-size: 16px;
        color: #666666;
        margin-bottom: 1em;
        text-align: center;
    }
    .top {
        text-align: center;
        .text-lg-space {
            margin-top: 0.3rem;
        }
        .text-sm-space {
            margin-top: 0.1rem;
        }
        .top-pic-wrap {
            margin: 0 auto 0.9rem auto;
        }
        .line {
            width: 100%;
            height: 50%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .pic-item {
            width: 2.8rem;
            height: 1.3rem;
            border: 0.01rem solid #f3f4f6;
            margin: 0.1rem;
        }
        .pic-item:hover {
            border: 0.01rem solid #ff8b00;
        }
        .pic-item-img {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .pic-item-div {
            width: 100%;
            height: 100%;
            visibility: hidden;
        }
        .pic-item:hover {
            .pic-item-img {
                display: none;
            }
            .pic-item-div {
                padding-top: 0.35rem;
                visibility: visible;
                h5 {
                    font-size: .2rem;
                    margin-bottom: 0.1rem;
                }
            }
        }
        .line-space {
            padding-top: 0.2rem;
        }
    }
    .qwnl-bg {
        background: url("../../images/picture/ds_bg.jpg") no-repeat;
    }
    .middle {
        width: 100%;
        text-align: center;
        .middle-content {
            height: 6.6rem;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .left {
            width: 20%;
            height: 100%;
        }
        .tab {
            margin-top: 1rem;
            width: 100%;
            height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            font-size: 20px;
            background-color: #1f222b;
            cursor: pointer;
        }
        .tab-space {
            margin-top: 0.2rem;
        }
        .active {
            background-color: #007eff;
            color: #ffffff;
        }
        .right {
            width: 80%;
            height: 100%;
            position: relative;
        }
        .dc-list {
            position: absolute;
            z-index: 99;
            width: 100%;
            text-align: center;
            color: #c6d4fd;
            top: 1rem;
        }
        .dc-item {
            display: inline;
            margin-right: 0.3rem;
            &:before {
                content: '';
                display: inline-block;
                width: .1rem;
                height: .1rem;
                border-radius: 50%;
                margin-right: .05rem;
            }
            &.rdc:before {
                background: #ff8b00;
            }
            &.cdc:before {
                border-radius: 0;
                width: 0;
                height: 0;
                border-width: 0 0.05rem  0.1rem;
                border-color:  transparent transparent #3cd479;
                border-style: solid;
            }
            &.dc:before {
                background: #ff3434;
            }
        }
        .dc-num {
            color: #fff;
        }
        .hide {
            display: none;
        }
        .content {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding-bottom: 0.55rem;
            img {
                height: 100%;
            }
        }
    }

}
@media screen and (min-width: 840px) and (max-width: 1080px) {
    .e-commerce {
        .middle .middle-content .tab {
            font-size: 16px;
        }
    }
}
@media screen and (min-width: 481px) and (max-width: 839px) {
    .e-commerce {
        .middle .middle-content .tab {
            font-size: 16px;
        }
    }
}
@media screen and (max-width: 480px) {
    .e-commerce {
        .sub-title {
            font-size: 16px;
        }
        .sub-content {
            font-size: 12px;
            margin: 0.1rem 0 !important;
            text-align: center;
        }
        .top {
            margin: 0 0 0.1rem 0;
            padding: 0.15rem;
            box-sizing: border-box;
            .top-pic-wrap {
                margin: 0.2rem auto;
            }
            .line {
                height: auto;
                flex-wrap: wrap;
            }
            .pic-item {
                width: 44%;
                height: 0.8rem;
                border: 0.01rem solid #f3f4f6;
                margin: 0.05rem;
            }
            .pic-item-img {
                img {
                    width: 1.2rem;
                }
            }
            .pic-item:hover {
                display: table;
                .pic-item-div {
                    visibility: visible;
                    display: table-cell;
                    vertical-align: middle;
                    padding-top: 0;
                    h5 {
                        font-size: 14px;
                        margin-bottom: 0.05rem;
                    }
                    p {
                        font-size: 12px;
                    }
                }
            }
        }
        .middle {
            width: 100%;
            height: auto;
            text-align: center;
            .sub-title {
                margin-top: 0.3rem;
                color: #ffffff;
            }
            .middle-content {
                margin-top: 0.2rem;
                height: auto;
                display: block;
                align-items: center;
            }
            .left {
                width: auto;
                height: auto;
                display: flex;
                padding-bottom: 0.17rem;
                border-bottom: solid 2px #39405d;
                margin: 0 0.15rem;
            }
            .tab {
                margin-top: 0;
                width: 100%;
                height: 0.2rem;
                line-height: 0.2rem;
                text-align: center;
                font-size: 12px;
                box-shadow: 0 0;
                color: #b4b4b4;
                background-color: transparent;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }
            .tab-space {
                margin-top: 0;
            }
            .active {
                background-color: transparent;
                color: rgba(0, 126, 255, 0.6);
            }
            .arrow {
                width: 0.1rem;
                height: 0.1rem;
                background-color: #0d0d17;
                position: absolute;
                top: -0.07rem;
                z-index: 2;
                transform: rotate(45deg);
                border-top: solid 2px #39405d;
                border-left: solid 2px #39405d;
            }

            .tab0 {
                left: 26%;
            }
            .tab1 {
                left: 71%;
            }
            .right {
                width: auto;
                height: 100%;
                position: relative;
                padding: 0.15rem;
            }
            .dc-list {
                top: .1rem;
            }
            .hide {
                display: none;
            }
            .content {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                padding-bottom: 0.3rem;
                img {
                    height: auto;
                }
            }
        }

    }
}
</style>